import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PesquisaGeralService } from 'src/app/modules/projeto-completo/services/pesquisa-geral.service';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ComboVinculo, Processo, TipoVinculacaoOptions, TipoVinculacao } from '../../models/processo';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { SeiService } from '../../services/sei.service';
import { ProaService } from '../../services/proa.service';

@Component({
  selector: 'app-processo-edit',
  templateUrl: './processo-edit.component.html',
  styleUrls: ['./processo-edit.component.scss']
})
export class ProcessoEditComponent extends BaseFormComponent<Processo> implements OnInit {
  
  sistema:string = '';
  action:string = 'Nova';
  type:string;
  id:number;
  project_id:number;
  validate:boolean = false;
  errorValidate:string = '';
  tipoVinculacao:TipoVinculacao[] = [];
  currentService;
  comboVinculos:ComboVinculo;

  constructor(
    public activatedRoute: ActivatedRoute,
    private seiService:SeiService,
    private proaService:ProaService,
    public router: Router,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
    private maskService: MaskService
  ) {
    super(activatedRoute);
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.project_id = +info.id;
    });
    this.id = +this.activatedRoute.snapshot.params['id'];
    this.type = this.activatedRoute.snapshot.params['type'];
    const entidade = this.activatedRoute.snapshot.params['entidade'];
    console.log(entidade)
    if(entidade == 'proa'){
      this.currentService = this.proaService;
      this.sistema = 'PROA';
    }
    else if(entidade == 'sei'){
      this.currentService = this.seiService;
      this.sistema = 'SEI';
    }
    else{
        this.msgError('Erro interno (service not found);');
    }
    this.tipoVinculacao = TipoVinculacaoOptions;
    this.getCombo();
    if(this.type == 'edit'){
      this.action = "Editar";
      this.get();
    }
    else{
      this.initForm();
      this.loaded();
    }
    
  }
  get(){
    this.currentService.getById(this.id).subscribe({
      next: (res: Processo) => {
        this.entity = res;
        this.initForm();
        this.loaded();
      },
      error: (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      },
    })
  }

  getCombo(){
    this.currentService.getComboVinculos(this.project_id).subscribe({
        next: (res) => {
          this.comboVinculos = res;
        },
        error: (error) => {
          this.msgError(error.error.message);
        },
      });
  }

  initForm() {
    this.form = new FormGroup({
      numero_processo: new FormControl({ value: '', disabled: this.type === 'edit' }, [Validators.required]),
      descricao: new FormControl('', [Validators.maxLength(255)]),
      pf_processo_vinculo: new FormArray([])
    });
    this.form?.get('numero_processo')?.valueChanges?.subscribe(valor => {
      const mascarado = this.onMaskProcesso(valor);
      if (valor !== mascarado) {
        this.form?.get('numero_processo')?.setValue(mascarado, {
          emitEvent: false
        });
      }
    });

    if (this.entity) {
      this.form?.patchValue(this.entity);
      if (this.entity?.pf_processo_vinculo?.length) {
        const vinculosArray = this.getVinculos();
        vinculosArray.clear();
        this.entity.pf_processo_vinculo.forEach(v => {
          vinculosArray.push(
            new FormGroup({
              id: new FormControl(v.id, Validators.required),
              tipo_vinculacao: new FormControl(v.tipo_vinculacao, Validators.required),
              item_id: new FormControl(v.item_id, Validators.required)
            })
          );
        });
      }
    }
  }

  newVinculo(): void {
    this.getVinculos().push(
      new FormGroup({
        tipo_vinculacao: new FormControl(null, Validators.required),
        item_id: new FormControl(null, Validators.required)
      })
    );
  }

  removeVinculo(index:number): void {
    this.getVinculos().removeAt(index);
  }

  check(canSave: boolean = false): void{
    this.errorValidate = '';
    const processNumber = this.form?.get('numero_processo').value;
    
    if (this.form?.get('numero_processo').hasError('incorrect')) {
      delete this.form.get('numero_processo').errors['incorrect'];
      this.form.get('numero_processo').updateValueAndValidity();
    }
    if(processNumber){
      const number = processNumber.replace(/[^0-9]/g, '');
      this.loading();
      this.currentService.checkProcess(this.project_id, number).subscribe(
        (res) => {
          this.validate = res? true: false;
          this.loaded();
          
          if (canSave) {
            this.salvar();
          }
        },
        (error) => {
          this.errorValidate = error?.error?.message ?? 'Não foi possível encontrar o processo.';
          this.validate = false;
          this.form.get('numero_processo').setErrors({'incorrect': true});
          this.loaded();
        },
      )
    }
    else{
      this.validate = false;
    }
  }

  salvar(): void {
    if(this.id || this.validate){
      const msg = "Deseja salvar as alterações?"
      this.alertConfirmation(null,msg).subscribe((confirmed) => {
          if (confirmed) {
            this.onSalvar();
          }
        }
      );
    }
    else{
      this.check(true);
    }
  }
  deletar(): void {
    if(this.id){
      const msg = "Deseja realmente deletar?"
      this.alertConfirmation(null,msg).subscribe((confirmed) => {
          if (confirmed) {
            this.onDelete();
          }
        }
      );
    }
  }

  getDataCreate() {
    return Object.assign({}, this.form?.value);
  }

  onSalvar(){
    if (this.form?.valid) {
      this.loading();
      var newData = this.getDataCreate();
      newData['projeto_id'] = this.project_id;
      newData['numero_processo'] = newData['numero_processo']?.replace(/[^0-9]/g, '');
      this.currentService.updateProcess(newData, this.id ?? null).subscribe({
        next: (res) => {
          this.form?.markAsPristine();
          if(this.id){
            this.confirmation("Alterado com sucesso!").subscribe(() => {
              window.location.reload();
            })
          }
          else{
            this.confirmation("Criado com sucesso!").subscribe(() => {
              this.router.navigate(['../edit/' + res.id], { relativeTo: this.activatedRoute });
            });
          }
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
    }
  }
  onDelete(){
    this.loading();
    this.currentService.delete(this.id).subscribe({
      next: (res) => {
        this.confirmation("Criado com sucesso!").subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  
  voltar() {
    if(this.type == 'edit'){
      this.router.navigate(['../../../'], { relativeTo: this.activatedRoute });
    }
    else{
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }
  }

  getVinculos(): FormArray {
    return this.form?.get('pf_processo_vinculo') as FormArray;
  }


  getComboLink(vinculo: any): any[] {
    const tipo = vinculo?.get('tipo_vinculacao')?.value;
    if (this.comboVinculos && tipo && this.comboVinculos[tipo]) {
       return this.comboVinculos[tipo];
    }
    return [];
  }

  onMaskProcesso(valor: string): string{
    this.validate = false;
    return this.maskService.mascaraProcesso(valor);
  }

}
